import { createIframeApp } from './createIframeApp.js'

// DS app shell. Hosted inside the project's own context so tokens, themes,
// shared libraries, and functions all come from the project being previewed.
// `DesignSystemNavbar` / `DesignSystemScene` are expected to be registered
// via the project's sharedLibraries (brand/shared) — we do NOT merge in the
// outer editor's ds components, same isolation contract as renderProject.
const dsShell = {
  flow: 'column',
  height: '100vh',
  width: '100vw',
  gap: '0',
  overflow: 'hidden',
  DesignSystemNavbar: {},
  DesignSystemScene: { flex: '1' }
}

export async function embedDesignSystem (iframeNode, data, initialState = {}) {
  const result = await createIframeApp(iframeNode, data, dsShell, {
    path: '/',
    contextOverrides: {
      pages: undefined,
      app: undefined,
      router: false,
      state: { ...(data.state || {}), ...initialState }
    }
  })
  if (result) {
    iframeNode.__dsRootState = result.state
    iframeNode.__dsApp = result
  }
  return result
}
